import { GIFEncoder, quantize, applyPalette } from "gifenc";
import { renderChartCanvas, downloadBlob } from "./exportChartPng";

const FRAME_MS = 1500, LAST_MS = 3000, WIDTH = 1200;

/** Animated GIF of the timeline: one frame per year, same composite as the PNG, 1200px wide, loops forever.
 *  `prepareYear(y)` must switch the chart to that year and resolve once React has committed the frame. */
export async function exportTimelineGif({ years, prepareYear, getSvg, optsFor, fileName, onProgress }) {
  const gif = GIFEncoder();
  for (let i = 0; i < years.length; i++) {
    await prepareYear(years[i]);
    const canvas = await renderChartCanvas(getSvg(), { ...optsFor(years[i]), targetWidth: WIDTH });
    const { data, width, height } = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
    const palette = quantize(data, 256);
    const index = applyPalette(data, palette);
    gif.writeFrame(index, width, height, { palette, delay: i === years.length - 1 ? LAST_MS : FRAME_MS, repeat: 0 });
    if (onProgress) onProgress(i + 1, years.length);
  }
  gif.finish();
  downloadBlob(new Blob([gif.bytes()], { type: "image/gif" }), fileName);
}
